import React, { Component } from 'react';
import Message from './ValidationMessage';
import InlineField from './InlineField';

export class DollarPercentField extends Component {

  numberBetween(min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return (value, previousValue, allValues) => {
      return (value < Number(min)) ? Number(min) : (value > Number(max)) ? Number(max) : Number(value);
    }
  }


  render() {
    let { intl, translation, input, required, label, placeholder, id, currency, displayType = "edit", onDollarClick, onPercentClick, isPercent, options = {}, min, max, meta: { touched, error, warning }, amount } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
      }
    }

    if (displayType === 'inline') {

      let content = "";
      if ((!isPercent)) {
        content = intl.formatNumber((amount ? amount : input.value), {
          currency: (currency || 'USD').toUpperCase(),
          style: 'currency'
        });
      }

      if (isPercent) {
        content = `${input.value}%`
      }

      return <InlineField fieldType='renderDollarPercent' content={content} label={label} translation={translation} id={id} />;

    }

    return (
      <div className={`${required && 'required'} field`}>
        <label>{label}</label>
        <div className="ui right action input field">
          <input readOnly={options.readOnly || false} {...input} type={"number"} placeholder={placeholder} min={min} max={max} />
          <div onClick={onDollarClick} className={`ui icon ${(!isPercent) ? "blue" : ""} button`} >
            $
        </div>
          <div onClick={onPercentClick} className={`ui icon ${(isPercent) ? "blue" : ""} button`} >
            %
        </div>
        </div>
        <div><Message show={touched} message={error} /><Message show={touched} message={warning} /></div>
      </div>
    );
  }
}




export function CURRENCY({ allowNegative = false, currencyCode = 'USD', locales = [] } = {}) {
  return (value) => {

    if (value === "") {
      return Number(value);
    }

    const amount = allowNegative ? Number(value) : Math.abs(Number(value));
    const opts = {
      style: 'currency',
      currencyDisplay: 'code',
      useGrouping: false,
      currency: currencyCode.toUpperCase(),
    };

    const formattedNumber = new Intl.NumberFormat(locales, opts).format(amount);
    return Number(formattedNumber.replace(currencyCode, ''));
  };
}

export const asCurrency = (amount, allowNegative, currencyCode) => {
  if (allowNegative) return CURRENCY({ allowNegative, currencyCode })(amount);
  return CURRENCY()(amount);
};


export const DECIMAL = (places, min, max, maxDecimalPlace) => {
  return (value) => {
    if (places) {
      return Number(value).toFixed(places);
    }
    if (min !== null) {
      if (value < min) {
        value = min;
      }
    }
    if (max !== null) {
      if (value > max) {
        value = max;
      }
    }
    if (maxDecimalPlace != null) {
      if (countDecimalPlaces(value, maxDecimalPlace) > maxDecimalPlace)
        return Number(value).toFixed(maxDecimalPlace);
    }

    return value;
  };
};

export const asDecimal = (amount) => {
  return DECIMAL()(amount);
};


function countDecimalPlaces(num, maxDecimalPlace) {
  var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) { return maxDecimalPlace }
  return Math.max(
    0,
    // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0)
    // Adjust for scientific notation.
    - (match[2] ? +match[2] : 0));
}


/* 
  EXAMPLE:
          <Field
            name={`${(this.state.discount_is_pct) ? `product_promotions.impact.discount.percent` : `product_promotions.impact.discount.amount`}`}
            component={renderDollarPercent}
            label={"Discount"}
            onDollarClick={this.setToDiscountUnit.bind(this)}
            onPercentClick={this.setToDiscountPercent.bind(this)}
            displayType={viewMode ? 'inline' : 'edit'}
            isPercent={this.state.discount_is_pct}
            translation={{ label: { message: messages.discount } }}
            parse={(this.state.discount_is_pct) ? Input.DECIMAL(null, 0, null) : Input.CURRENCY()}
          />
*/

